'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tradeTypeCodeToText = require('./tradeTypeCodeToText');

var _tradeTypeCodeToText2 = _interopRequireDefault(_tradeTypeCodeToText);

var _typeHasBarrier = require('./typeHasBarrier');

var _typeHasBarrier2 = _interopRequireDefault(_typeHasBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (code, barrier) {
    return (0, _tradeTypeCodeToText2.default)(code) + ((0, _typeHasBarrier2.default)(code) ? ' ' + barrier : '');
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/trade/tradeToFriendlyType.js
// module id = 129
// module chunks = 0